import Shipments from '../Shipments';
import ShipmentGroups from '../ShipmentGroups';
import Orders from '../Orders';

Shipments.setDependencyDocument('ShipmentGroups', ShipmentGroups);
ShipmentGroups.setDependencyDocument('Shipments', Shipments);
ShipmentGroups.setDependencyDocument('Orders', Orders);
Orders.setDependencyDocument('Shipments', Shipments);

export default Shipments;
